import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'USER_SETTINGS',
  entryPoint: '/user-settings',
  collectionName: 'settings',
});

export default triggers;



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/user/triggers.js